// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  staging: true,
  dev: false,
  initLogRocket: false,
  firebaseConfig: {
    apiKey: "AIzaSyAZO1uQCZ-pjwnsGEjnBguxhI_0J-zdg0s",
    authDomain: "",
    projectId: "sim-apps-analytics",
    storageBucket: "",
    messagingSenderId: "",
    appId: "1:1005088735702:web:a09cdb1d20db5b99152477",
    measurementId: "G-KP6J23H0WL"
  },
  apiBaseUrl: "http://localhost:5000/api/",
  // apiBaseUrl: "https://api.safetyinminutes.ca/api/",

  //apiBaseUrl:"https://safetyinminute-dev-inventory.azurewebsites.net/api/"
  //apiBaseUrl:"https://dev-safetyinminutes.azurewebsites.net/api/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
